import React from "react";

import styles from "./ListCard.module.scss";
import { OrderProps } from "../../types/order";

type Props = {
  order: OrderProps;
};

const ListCard = ({ order }: Props) => {
  const isInSet = order?.item?.isinset || false;

  return (
    <div className={styles.ListCard}>
      {/* Header with Order ID and Status */}
      <div className="flex items-center gap-2 mb-4">
        <span className="text-gray-600 text-lg font-medium">Order No:</span>
        <span className="text-primary-1 text-xl font-bold">
          {order.id}
        </span>
        {isInSet && (
          <span className="bg-green-100 text-green-700 text-sm font-semibold px-3 py-1.5 rounded-full">
            સેટ
          </span>
        )}
      </div>

      {/* Centered Image */}
      <div className="flex justify-center mb-4">
        <div className="w-[140px] h-[140px] rounded-xl overflow-hidden bg-white shadow-sm border border-gray-100">
          {order.image ? (
            <img
              className="w-full h-full object-cover"
              src={`${order.image}?order=${order.id}`}
              alt=""
            />
          ) : (
            <div className="w-full h-full flex items-center justify-center bg-gray-100">
              <span className="text-gray-400 text-sm">No Image</span>
            </div>
          )}
        </div>
      </div>

      {/* Details */}
      <div className="text-center">
        {/* Party Name */}
        <h3 className="text-primary-1 font-bold text-xl mb-2">
          {order.party?.firm_name || "-"}
        </h3>

        {/* Item Name */}
        <p className="text-gray-600 text-lg mb-3">
          {order.item?.name || "-"}
        </p>

        {/* Stats */}
        <div className="bg-gray-50 rounded-xl p-3 space-y-2">
          {/* Order Qty */}
          <div className="flex justify-between items-center">
            <span className="text-gray-500 text-base">ઓર્ડર નંગ:</span>
            <span className="text-primary-1 font-bold text-lg">{order.qty || 0}</span>
          </div>

          {isInSet ? (
            <>
              {/* Kesh */}
              {((order.set_delivered_qty || 0) > 0 || (order.set_delivered_weight || 0) > 0) && (
                <div className="flex justify-between items-center">
                  <span className="text-gray-500 text-base">કેશ:</span>
                  <span className="text-primary-2 font-bold text-lg">
                    {order.set_delivered_qty || 0} નંગ | {(order.set_delivered_weight || 0).toFixed(3)} કિ.
                  </span>
                </div>
              )}

              {/* Patta */}
              {((order.delivered_qty || 0) > 0 || (order.delivered_weight || 0) > 0) && (
                <div className="flex justify-between items-center">
                  <span className="text-gray-500 text-base">પટ્ટા:</span>
                  <span className="text-green-600 font-bold text-lg">
                    {order.delivered_qty || 0} નંગ | {(order.delivered_weight || 0).toFixed(3)} કિ.
                  </span>
                </div>
              )}
            </>
          ) : (
            <>
              {/* Regular Item - Delivered Qty & Weight */}
              {((order.delivered_qty || 0) > 0 || (order.delivered_weight || 0) > 0) && (
                <div className="flex justify-between items-center">
                  <span className="text-gray-500 text-base">પરત:</span>
                  <span className="text-green-600 font-bold text-lg">
                    {order.delivered_qty || 0} નંગ | {(order.delivered_weight || 0).toFixed(3)} કિ.
                  </span>
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default ListCard;